import React, { useEffect } from "react";
import ProductDetail from "../components/ProductDetail";

const DetailPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <ProductDetail />
        </>
    )
}

export default DetailPage;